import { render } from "./Contact.vue?vue&type=template&id=02542f1e"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=02542f1e&lang=scss"
script.render = render

export default script